import React, {useState} from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import { useSystemMessage } from '../../../../hooks/useSystemMessage';
import useLoading from '../../../../hooks/useLoading';

import { roomMemberApi } from '../../../../apis/admin/room/roomMemberApi';

import { ChangeRoleModalParams } from '../../../../types/admin/room';
import {ApiClientError} from "../../../../apis/errors";
import useAppRouter from "../../../../hooks/useAppRouter";
import {logError} from "../../../../libs/utils/logError";

interface ChangeRoleModalProps {
  modalParams: ChangeRoleModalParams | undefined;
  onSubmitted: (isChange: boolean) => Promise<void>;
}

export const ChangeRoleModal = (props: ChangeRoleModalProps) => {
  const { modalParams, onSubmitted } = props;

  const [modalTitle, setModalTitle] = React.useState<string>("");

  const withLoading = useLoading();
  const location = useLocation();
  const { success } = useSystemMessage();
  const [ apiClientError, setApiClientError] = useState<ApiClientError | null>(null);
  const { goto } = useAppRouter();


  React.useEffect(() => {
    const fetch = async () => {
      if (modalParams!.mode === "owner") {
        setModalTitle("オーナー");
      } else if (modalParams!.mode === "primarySales") {
        setModalTitle("主営業担当");
      }
    };
    fetch();
  });

  const handleChangeRole = async () => {
    withLoading(async () => {
      setApiClientError(null);

      try {
        if (modalParams!.mode === "owner") {
          await roomMemberApi.changeOwner(
            {
              userId: modalParams!.userId,
              roomId: modalParams!.roomId,
            },
            {}
          );
        } else if (modalParams!.mode === "primarySales") {
          await roomMemberApi.changePrimarySalesman(
            {
              userId: modalParams!.userId,
              roomId: modalParams!.roomId,
            },
            {}
          );
        }

        await onSubmitted(true);
        await success(`${modalParams!.userName} を${modalTitle}に変更しました。`);

      } catch (e) {
        await logError(
          location.pathname,
          'ロールの変更に失敗しました。',
          e
        );

        if (e instanceof ApiClientError) {
          setApiClientError(e);
          return;
        }

        goto('internalServerError');
      }
    });
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted(false)}
        className="w-1/3"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
        style={{
          content: {
            position: 'fixed',
            top: '1rem'
          }
        }}
      >
        <section className="modal-background">
          <div className="form-modal-container">
            <div className="form-modal-title">
              <h1 className="font-semibold">{modalTitle}変更</h1>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => onSubmitted(false)}
              >
                ×
              </button>
            </div>
            <div className="form-modal-content">
              <div className="mb-4 text-danger text-xs">
                { apiClientError?.message }
              </div>

              <div className="text-primary text-sm font-semibold grid grid-cols-1 w-full">
                <p>
                  { modalParams !== undefined ? modalParams.userName : "" } を
                  {modalTitle}に変更します。
                </p>
                <p>よろしいですか？</p>
              </div>
            
            </div>
            <div className="form-modal-footer-container">
              <div className="form-modal-footer">
                <button
                  className="btn-sub"
                  type="button"
                  onClick={() => onSubmitted(false)}
                >
                  キャンセル
                </button>
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() => handleChangeRole()}
                >
                  更新
                </button>
                
              </div>
            </div>


          </div>
        </section>
      </ReactModal>
    </>
  );
}